<template>
    <v-snackbar v-model="offersExpired" :timeout="-1" location="top" color="error">
        {{ $t('offers_expired') }}
        <template v-slot:actions>
            <v-btn variant="text" color="inherit" @click="refresh">
                {{ $t('refresh') }}
            </v-btn>
        </template>
    </v-snackbar>
</template>

<script lang="ts">
    import {Component, Emit, Prop, Vue} from 'vue-facing-decorator'
    import {EventBus, OFFER_EXPIRED_EVENT} from '@/utils/event-bus'

    @Component
    export class ExpiredOffersSnackbar extends Vue {
        @Prop() isOffersExpired
        @Prop({default: false, type: Boolean}) disableRestart

        offersExpired = false
        alertTimer

        @Emit()
        refresh() {
            this.offersExpired = false
            if (!this.disableRestart) this.start()
        }

        start() {
            this.alertTimer = setInterval(() => {
                if (this.isOffersExpired()) {
                    this.offersExpired = true
                    EventBus.$emit(OFFER_EXPIRED_EVENT)
                    clearInterval(this.alertTimer)
                }
            }, 3000)
        }

        mounted() {
            this.start()
        }

        beforeUnmount() {
            clearInterval(this.alertTimer)
        }
    }

    export default ExpiredOffersSnackbar
</script>
